import { PropTypes } from 'typed/imports';
import { PureComponent, ReactEventHandler, ComponentEventHandler1 } from 'typed/components/utils';
import { ReactNode } from 'react';
import { default as FormattedResource, Resource, resourcePropType, isResource } from '../FormattedResource/FormattedResource';
import './ExpandPanel.less';

export const AUTO_ICON = 'AUTO_ICON';

interface Props {
    opened?: boolean;
    title?: Resource | ReactNode | null;
    icon?: string | ReactNode | null;
    disabled?: boolean;
    className?: string;
    onOpen?: ComponentEventHandler1<unknown>;
    onClose?: ComponentEventHandler1<unknown>;
}

interface State {
    opened: boolean;
}

export default class ExpandPanel extends PureComponent<Props, State>{
    static readonly AUTO_ICON = AUTO_ICON;

    static readonly propTypes = {
        opened: PropTypes.bool,
        title: PropTypes.oneOfType([resourcePropType, PropTypes.node]),
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onOpen: PropTypes.func,
        onClose: PropTypes.func
    };

    static readonly defaultProps = {
        opened: undefined,
        icon: AUTO_ICON,
        disabled: false,
        tabIndex: 0,
        className: ''
    };

    state: State = { opened: false };

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: Props) {
        if (nextProps.opened !== undefined && nextProps.opened !== this.state.opened) {
            this.setState({ opened: nextProps.opened });
        }
    }

    private _onClick: ReactEventHandler = (event) => {
        if (!this.state.opened) {
            if (this.props.onOpen) {
                this.props.onOpen(this, event);
            }
        }
        else {
            if (this.props.onClose) {
                this.props.onClose(this, event);
            }
        }

        if (this.props.opened === undefined) {
            this.setState({ opened: !this.state.opened });
        }
    }

    render() {
        const
            { title, disabled, className } = this.props,
            opened = !disabled && this.state.opened,
            icon = this.props.icon !== AUTO_ICON ? this.props.icon : `caret-${opened ? 'up' : 'down'}`;

        return (
            <div
                className={
                    'expand-panel control ' + className +
                    (opened ? ' active' : '') +
                    (disabled ? ' disabled' : '')
                }>
                <div className="header flex-row" onClick={!disabled ? this._onClick : undefined}>
                    {
                        title ?
                            <span className="title main-col">{isResource(title) ? <FormattedResource resource={title} /> : title}</span> :
                            null
                    }
                    {
                        icon ?
                            typeof icon === 'string' ?
                                <span className={`icon fa fa-${icon}`} /> :
                                <span className="icon">{icon}</span> :
                            null
                    }
                </div>
                {opened ? <div className="content">{this.props.children}</div> : null}
            </div >
        );
    }
}
